module.exports = __webpack_public_path__ + "assets/img/3_big.d27c5914.png";